import { Box, Typography } from "@mui/material";
import React, { useContext } from "react";
import { ATTICUS_PAGE_PREFIX } from "../../../constants";
import { Heading } from "./Heading";
import PersonImage1 from "../../assets/person-1x.png";
import PersonImage15 from "../../assets/person-1.5x.png";
import PersonImage2 from "../../assets/person-2x.png";
import PersonImage3 from "../../assets/person-3x.png";
import Estate1 from "../../assets/estate-1x.png";
import Estate15 from "../../assets/estate-1.5x.png";
import Estate2 from "../../assets/estate-2x.png";
import Estate3 from "../../assets/estate-3x.png";
import GetConnectedImage1 from "../../assets/get-connected-advisor-1x.png";
import GetConnectedImage15 from "../../assets/get-connected-advisor-1.5x.png";
import GetConnectedImage2 from "../../assets/get-connected-advisor-2x.png";
import GetConnectedImage3 from "../../assets/get-connected-advisor-3x.png";
import handsClipboard1 from "../../assets/hands-clipboard-1x.png";
import handsClipboard15 from "../../assets/hands-clipboard-1.5x.png";
import handsClipboard2 from "../../assets/hands-clipboard-2x.png";
import handsClipboard3 from "../../assets/hands-clipboard-3x.png";
import Page from "../../../components/Page";
import { useAuthContext } from "../../../AuthContextWrapper";
import { useParams } from "react-router-dom";
import { Sections as OnBoardingSections } from "../OnBoarding/flow";
import { Sections as FinancialConvoSections } from "../FinancialConversation/flow";
import { Sections as PrimaryHomeSections } from "../PrimaryHome/flow";

interface Props {
  children: JSX.Element;
  title?: string | JSX.Element;
  subTitle?: string | JSX.Element;
  hideSectionHeading?: boolean;
  centerContent?: boolean;
}

const contentAndHeaderMaxWidth = {
  md: 640,
  sm: "none",
  xs: "none",
} as const;

export const FlowScreenWrapper = ({
  children,
  title,
  subTitle,
  hideSectionHeading,
  centerContent,
}: Props): JSX.Element => {
  const { flow } = useAuthContext()
  const { screenName } = useParams();
  const currentScreen = flow?.getCurrentFlowScreen(screenName);
  const section = flow?.getSection(currentScreen);

  const getImage = (section: string | undefined): JSX.Element | undefined => {
    switch (section) {
      case OnBoardingSections.AboutDeceased:
        return (
          <img
            srcSet={`${PersonImage15} 1.5x, ${PersonImage2} 2x, ${PersonImage3} 3x`}
            src={PersonImage1}
            alt={section}
            title={section}
            // style={{
            //   marginLeft: "-8px",
            // }}
          />
        );
      case OnBoardingSections.AboutEstate:
        return (
          <img
            srcSet={`${Estate15} 1.5x, ${Estate2} 2x, ${Estate3} 3x`}
            src={Estate1}
            alt={section}
            title={section}
            style={{ position: "relative", top: "-4px" }}
          />
        );
      case FinancialConvoSections.AboutYou:
        return (
          <img
            srcSet={`${PersonImage15} 1.5x, ${PersonImage2} 2x, ${PersonImage3} 3x`}
            src={PersonImage1}
            alt={section}
            title={section}
            // style={{
            //   marginLeft: "-8px",
            // }}
          />
        );
      case FinancialConvoSections.AboutEstate:
        return (
          <img
            srcSet={`${Estate15} 1.5x, ${Estate2} 2x, ${Estate3} 3x`}
            src={Estate1}
            alt={section}
            title={section}
            style={{ position: "relative", top: "-4px" }}
          />
        );
      case FinancialConvoSections.GetConnected:
        return (
          <img
            srcSet={`${GetConnectedImage15} 1.5x, ${GetConnectedImage2} 2x, ${GetConnectedImage3} 3x`}
            src={GetConnectedImage1}
            alt={section}
            title={section}
            style={{ position: "relative", top: "-4px" }}
          />
        );
      case PrimaryHomeSections.PrimaryHome:
        return (
          <img
            srcSet={`${handsClipboard15} 1.5x, ${handsClipboard2} 2x, ${handsClipboard3} 3x`}
            src={handsClipboard1}
            alt={section}
            title={section}
            style={{ position: "relative", top: "-4px" }}
          />
        );
    }
  };

  return (
    <Page title={`${ATTICUS_PAGE_PREFIX} - ${currentScreen?.name}`}>
      <>
        {hideSectionHeading !== true && (
          <Heading image={getImage(section)}>{section || ""}</Heading>
        )}
        <Box
          sx={{
            py: 2,
          }}
        >
          <Box
            sx={{
              mb: 2,
              maxWidth: contentAndHeaderMaxWidth,
            }}
          >
            {title &&
              (typeof title === "string" ? (
                <Typography
                  component="h2"
                  variant="h5"
                  sx={{
                    mb: 2,
                  }}
                >
                  {title}
                </Typography>
              ) : (
                title
              ))}
            {subTitle &&
              (typeof subTitle === "string" ? (
                <Typography variant="body1">{subTitle}</Typography>
              ) : (
                subTitle
              ))}
          </Box>
          <Box
            sx={{
              maxWidth: contentAndHeaderMaxWidth,
              mx: centerContent ? "auto" : 0,
            }}
          >
            {children}
          </Box>
        </Box>
      </>
    </Page>
  );
};
